/*
 * @Author: jhonsem
 * @Date: 2021-04-09 09:52:40
 * @Last Modified by: jhonsem
 * @Last Modified time: 2021-05-26 17:37:35
 */

import Vue from "vue";
import { ObservableActUsers } from "../types/type";
import nativeStorage from "@/utils/nativeStorage/native_storage";
import { ACT_USERS_MAP } from "@/utils/nativeStorage/local_keys/index";
import {
  FOLLOWER_FEED,
  LIKE_FEED,
  COMMENT_FEED
} from "./../earn_coins_consts/earn_coins_consts";
import { store } from "@/main";
import { GETTER_CLIENT_SETTINGS } from "@/store/constants/setting_types";
import { GETTER_LOGIN_INS_USER_LIST } from "@/store/constants/ins_user_info_types";

const observable_act_users_map: any = Vue.observable({
  act_users: []
});

// ----------------------------- getters -----------------------------
const act_users_getters = {
  act_users_map() {
    return observable_act_users_map;
  },
  act_users_list() {
    // 返回数组形式:
    return observable_act_users_map.act_users;
  },
  can_work_accounts() {
    const loggined_users_list = store.getters[GETTER_LOGIN_INS_USER_LIST];
    const work_users_list = loggined_users_list.filter((loggined_user: any) => {
      const act_user = this.get_act_user(loggined_user.user_id);
      if (
        act_user &&
        !act_user.is_login_required &&
        !act_user.is_act_limited &&
        !act_user.need_complete_profile
      ) {
        return true;
      }
    });
    return work_users_list;
  },
  can_work_api_accounts() {
    const loggined_users_list = store.getters[GETTER_LOGIN_INS_USER_LIST];
    const work_users_list = loggined_users_list.filter((loggined_user: any) => {
      const act_user = this.get_act_user(loggined_user.user_id);
      if (act_user && !act_user.is_login_required) {
        return true;
      }
    });
    return work_users_list;
  },
  get_act_user(user_id: string) {
    return observable_act_users_map.act_users.find((user: any) => {
      return user.user_id === user_id;
    });
  },
  get_act_user_index(user_id: string) {
    return observable_act_users_map.act_users.findIndex((user: any) => {
      return user.user_id === user_id;
    });
  },
  is_limit(user_id: string) {
    const act_user: any = this.get_act_user(user_id);
    return act_user && act_user.is_act_limited;
  },
  is_login_required(user_id: string) {
    const act_user: any = this.get_act_user(user_id);
    return act_user && act_user.is_login_required;
  },
  need_complete_profile(user_id: string) {
    const act_user: any = this.get_act_user(user_id);
    return act_user && act_user.need_complete_profile;
  },
  end_limit_time_stamp(user_id: string) {
    const act_user: any = this.get_act_user(user_id);
    return act_user && act_user.end_limit_time_stamp;
  },
  get_limit_config() {
    const { earn_limit } = store.getters[GETTER_CLIENT_SETTINGS];
    const {
      window_follow_limit,
      window_like_limit,
      window_comment_limit,
      ratelimit_followerwindow_size,
      ratelimit_slidingwindow_size,
      ratelimit_commentwindow_size
    } = earn_limit.level_1;
    return {
      follow_limit_count: window_follow_limit,
      like_limit_count: window_like_limit,
      comment_limit_count: window_comment_limit,
      follow_limit_period_time: ratelimit_followerwindow_size * 1000,
      like_limit_period_time: ratelimit_slidingwindow_size * 1000,
      comment_limit_period_time: ratelimit_commentwindow_size * 1000
    };
  }
};

// ----------------------------- mutation -----------------------------
const act_users_mutation = {
  reset_user_act_count(user_id: string, kind: string) {
    const act_user: any = act_users_getters.get_act_user(user_id);
    if (act_user) {
      const update_act_user: any = {};
      if (kind === FOLLOWER_FEED) {
        // follow
        update_act_user.follow_count = 0;
        update_act_user.follow_start_time_stamp = 0;
      } else if (kind === LIKE_FEED) {
        // like
        update_act_user.like_count = 0;
        update_act_user.like_start_time_stamp = 0;
      } else if (kind === COMMENT_FEED) {
        // commment
        update_act_user.comment_count = 0;
        update_act_user.comment_start_time_stamp = 0;
      }
      this.update_act_user(user_id, update_act_user);
    }
  },
  set_new_act_user(user_id: string) {
    // 设置当前act用户为全新的用户
    const new_act_user: any = {
      user_id,
      follow_count: 0,
      follow_start_time_stamp: 0,
      like_count: 0,
      like_start_time_stamp: 0,
      comment_count: 0,
      comment_start_time_stamp: 0,
      is_act_limited: false,
      is_login_required: false,
      need_complete_profile: false,
      end_limit_time_stamp: 0
    };
    this.update_act_user(user_id, new_act_user);
  },
  set_act_user_limit_end_time(user_id: string, end_limit_time_stamp: any) {
    this.update_act_user(user_id, {
      end_limit_time_stamp,
      is_act_limited: true
    });
  },
  update_act_user(user_id: string, update_act_user_map: any) {
    const act_user: any = act_users_getters.get_act_user(user_id);
    const act_user_index: any = act_users_getters.get_act_user_index(user_id);
    if (act_user) {
      observable_act_users_map.act_users.splice(act_user_index, 1, {
        ...act_user,
        ...update_act_user_map
      });
    } else {
      // 不存在act_users
      observable_act_users_map.act_users.push(update_act_user_map);
    }

    console.log("observable_act_user_map:", observable_act_users_map);
  }
};

// ----------------------------- action -----------------------------

const act_users_action = {
  async get_local_act_users_map() {
    const act_users_map = await nativeStorage.get(ACT_USERS_MAP);
    return act_users_map;
  },
  async refresh_local_save() {
    // 只存了数组
    await nativeStorage.set(ACT_USERS_MAP, observable_act_users_map.act_users);
  },
  async act_users_map_restore() {
    // 从本地取出放回内存：
    const act_users_map = await this.get_local_act_users_map();
    console.log("act_users_map get_local_act_users_map:", act_users_map);
    // 更新到内存
    if (act_users_map) {
      observable_act_users_map.act_users.push(...act_users_map);
    }
    console.log("observable_act_users_map resotre:", observable_act_users_map);
  },
  async update_act_user(user_id: string, update_map: any) {
    act_users_mutation.update_act_user(user_id, update_map);
    // 存储到本地
    this.refresh_local_save();
  },
  async add_new_act_user(user_id: string) {
    // 先从map中去找
    const act_user = act_users_getters.get_act_user(user_id);
    if (act_user) {
      // 已经存在本地缓存的用户,此时is_login_required需要reset
      act_user.is_login_required = false;
    } else {
      act_users_mutation.set_new_act_user(user_id);
    }
    // 存储到本地
    this.refresh_local_save();
  },
  check_is_reach_limit(user_id: string, kind: string) {
    const {
      follow_limit_count,
      like_limit_count,
      follow_limit_period_time,
      like_limit_period_time,
      comment_limit_count,
      comment_limit_period_time
    } = act_users_getters.get_limit_config();

    const now_time_stamp = new Date().valueOf();
    const act_user = act_users_getters.get_act_user(user_id);
    if (act_user) {
      if (kind === FOLLOWER_FEED) {
        // follow
        if (act_user.follow_start_time_stamp === 0) {
          act_user.follow_start_time_stamp = now_time_stamp;
        }
        if (
          now_time_stamp - act_user.follow_start_time_stamp >
          follow_limit_period_time
        ) {
          // reset
          act_users_mutation.reset_user_act_count(user_id, kind);
        }
        //
        if (
          act_user.follow_count >= follow_limit_count &&
          now_time_stamp - act_user.follow_start_time_stamp <=
            follow_limit_period_time
        ) {
          //   // need limit
          //   act_user.end_limit_time_stamp =
          //     follow_limit_period_time + act_user.follow_start_time_stamp;
          //   // limit
          //   act_user.is_act_limited = true;

          act_users_mutation.set_act_user_limit_end_time(
            user_id,
            follow_limit_period_time + act_user.follow_start_time_stamp
          );
        }
      } else if (kind === LIKE_FEED) {
        // =======================  like feed ======================
        if (act_user.like_start_time_stamp === 0) {
          act_user.like_start_time_stamp = now_time_stamp;
        }
        if (
          now_time_stamp - act_user.like_start_time_stamp >
          like_limit_period_time
        ) {
          // reset
          act_users_mutation.reset_user_act_count(user_id, kind);
        }
        if (
          act_user.like_count >= like_limit_count &&
          now_time_stamp - act_user.like_start_time_stamp <=
            like_limit_period_time
        ) {
          // need limit
          //
          //   act_user.end_limit_time_stamp =like_limit_period_time + act_user.like_start_time_stamp
          //   // limit
          //   act_user.is_act_limited = true;

          act_users_mutation.set_act_user_limit_end_time(
            user_id,
            like_limit_period_time + act_user.like_start_time_stamp
          );
        }
      } else if (kind === COMMENT_FEED) {
        // =======================  comment feed ======================
        if (act_user.comment_start_time_stamp === 0) {
          act_user.comment_start_time_stamp = now_time_stamp;
        }
        if (
          now_time_stamp - act_user.comment_start_time_stamp >
          comment_limit_period_time
        ) {
          // reset
          act_users_mutation.reset_user_act_count(user_id, kind);
        }
        if (
          act_user.comment_count >= comment_limit_count &&
          now_time_stamp - act_user.comment_start_time_stamp <=
            comment_limit_period_time
        ) {
          // need limit
          //
          //   act_user.end_limit_time_stamp =
          //     comment_limit_period_time + act_user.comment_start_time_stamp;
          //   // limit
          //   act_user.is_act_limited = true;
          act_users_mutation.set_act_user_limit_end_time(
            user_id,
            comment_limit_period_time + act_user.comment_start_time_stamp
          );
        }
      }
    }
    console.log("act_user:", {
      observable_act_users_map,
      act_user
    });
  },
  trigger_limit_count(user_id: string, kind: string) {
    // 先从map中去找
    const act_user = act_users_getters.get_act_user(user_id);
    if (act_user) {
      const update_map: any = {};
      const { follow_count, like_count, comment_count } = act_user;
      if (kind === FOLLOWER_FEED) {
        // follow
        update_map.follow_count = follow_count + 1;
      } else if (kind === LIKE_FEED) {
        // like
        update_map.like_count = like_count + 1;
      } else if (kind === COMMENT_FEED) {
        update_map.comment_count = comment_count + 1;
      }
      act_users_mutation.update_act_user(user_id, update_map);
      this.check_is_reach_limit(user_id, kind);
      // 存储到本地
      this.refresh_local_save();
    }
  },
  async trigger_login_required(user_id: string) {
    // 触发了某个用户的login_required:
    const act_user = act_users_getters.get_act_user(user_id);
    if (act_user) {
      act_user.is_login_required = true;
      // 存储到本地
      this.refresh_local_save();
    }
  },
  async feed_back_trigger_act_limit(user_id: string) {
    // 触发了某个用户的login_required:
    const { follow_limit_period_time } = act_users_getters.get_limit_config();
    const limit_time = new Date().valueOf() + follow_limit_period_time;
    const act_user = act_users_getters.get_act_user(user_id);
    if (act_user) {
      act_users_mutation.update_act_user(user_id, {
        is_act_limited: true,
        end_limit_time_stamp: limit_time
      });
      // 存储到本地
      this.refresh_local_save();
    }
  },
  async trigger_act_need_complete_profile(
    user_id: string,
    need_complete_profile: boolean
  ) {
    // 触发了某个用户的need_complete_profile
    const act_user = act_users_getters.get_act_user(user_id);
    if (act_user) {
      act_users_mutation.update_act_user(user_id, {
        need_complete_profile
      });
      // 存储到本地
      this.refresh_local_save();
    }
  }
};

export { act_users_getters, act_users_mutation, act_users_action };
